<template>
	<b-overlay :show="isAgencyConnecting" rounded="sm">
		<div class="conversations-page d-flex">
			<div v-if="currentAgency && !isAgencyConnecting" class="conversations-page--content px-2 py-2 px-md-4 py-md-4">
				<router-view :key="$route.fullPath"></router-view>
			</div>
		</div>
	</b-overlay>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Conversations",
	computed: {
		...mapGetters("agency", ["currentAgency", "isAgencyConnecting"]),
	},
};
</script>

<style lang="scss">
.conversations-page {
	width: 100%;
	height: 100%;
	&--content {
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
</style>
